export const corrector = (email) => (value) => {
    if (!email || !value.suggest)
        return value;
    return {
        ...value,
        corrected: email.replace(/@.*$/, `@${value.suggest}`),
        original: email
    };
};
